import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../store';

type Favourites = {
  goalIds: Array<string>;
};

export const initialState: Favourites = {
  goalIds: [],
};

export const favouriteSlice = createSlice({
  name: 'favourites',
  initialState,
  reducers: {
    toggleFavourite: (state, { payload: goalId }: PayloadAction<string>) => {
      if (state.goalIds.includes(goalId)) {
        state.goalIds.splice(state.goalIds.indexOf(goalId), 1);
      } else {
        state.goalIds.push(goalId);
      }
    },
    addFavourite: (state, { payload: goalId }: PayloadAction<string>) => {
      if (!state.goalIds.includes(goalId)) {
        state.goalIds.push(goalId);
      }
    },
    removeFavourite: (state, { payload: goalId }: PayloadAction<string>) => {
      if (state.goalIds.includes(goalId)) {
        state.goalIds.splice(state.goalIds.indexOf(goalId), 1);
      }
    },
    clearFavourites: (state) => {
      state.goalIds = [];
    },
  },
});

export const { toggleFavourite, addFavourite, removeFavourite, clearFavourites } =
  favouriteSlice.actions;

// Selectors
export const selectFavourites = (state: RootState) => state.favourites;

export const selectFavouriteGoalIds = (state: RootState) => state.favourites.goalIds;

export const isFavourited = (state: RootState, goalId: string) =>
  state.favourites.goalIds.includes(goalId);

export const hasFavourites = (state: RootState) =>
  state.favourites.goalIds.length > 0;

export default favouriteSlice.reducer;
